import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Search } from './../../../../Common/Tables/Search'
//import { InstructorBase } from './../../../../Layouts/Instructor/InstructorBase'
import { InstructorBase } from './../../../../Layouts/Instructor/V2/InstructorBase'
import { Confirm } from './../../../../Common/Modals/Confirm'
import { GetZtudents } from './../../../../../utilities/BL/Instructor/Ztudents'
import { Loading } from './../../../../Common/Loading'

import { LogErrors } from './../../../../../utilities/LogErrors'
import { ValidateSession } from './../../../../../utilities/BL/Sessions'
import { useFloatMessage, MESSAGE_TYPE } from './../../../../Providers/FloatMessage'
import { GetActiveZtudents as BLGetActiveZtudents, WsMonitor } from './../../../../../utilities/BL/Instructor/ZtudentView'
import { HELP_TYPE } from './../../../../../utilities/EL/HelpType'
import { WEBPAGES } from './../../../../../utilities/EL/WebPages'
import { ROLES } from './../../../../../utilities/EL/Roles'

//import { HELP_TYPE } from './../../../../Header/Header'
//import { useTawkChat } from './../../../../../Support/Chat/Chat'



// ==========================
// Config
// ==========================
const ACTIONS = {
  VIEWNOW: 'VIEWNOW'
}

// const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000'
// const WSS_URL = process.env.REACT_APP_API_URL_WSS || 'ws://localhost:5000/ws'

const API_BASE = process.env.REACT_APP_API_BASE_ISTE
const WSS_URL = process.env.REACT_APP_API_BASE_ISTE_WSS

// ==========================
// Helper de API (ajusta si ya lo tienes centralizado)
// GET /api/centers/{centerId}/online-students
// ==========================
async function GetOnlineZtudents(centerId) {
  try {
    const res = await fetch(`${API_BASE}/api/centers/${encodeURIComponent(centerId)}/online-students`, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'include' // si usas cookie de sesión
    })

    if (!res.ok) {
      const text = await res.text()
      return { success: false, message: `HTTP ${res.status}: ${text}` }
    }

    const data = await res.json()
    // Esperado del backend: [{ user, name, lastName, connectedAt }, ...]
    const rows = (data || []).map(s => ({
      idZtudiante: s.user,
      user: s.user,
      name: s.name,
      lastName: s.lastName,
      connectedAt: s.connectedAt
    }))

    return { success: true, data: rows }
  } catch (err) {
    return { success: false, message: err?.message || 'Error inesperado' }
  }
}

// ==========================
// Componente principal
// ==========================
const ZtudentView = () => {
  const navigate = useNavigate()
  const { showMessage } = useFloatMessage()

  const [isLoading, setIsLoading] = useState(true)

  // Lista única (mezcla de visibles/ocultos ya NO se usa)
  const [allRows, setAllRows] = useState([])
  const allRowsRef = useRef([])
  useEffect(() => { allRowsRef.current = allRows }, [allRows])

  // Búsqueda y ordenamiento
  const [searchText, setSearchText] = useState('')
  const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'asc' })

  // Confirm modal
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [actionTypeOfModal, setActionTypeOfModal] = useState(null)
  const [ztudentConfirmDetails, setZtudentConfirmDetails] = useState(null)

  // Último snapshot recibido
  const [lastSnapshot, setLastSnapshot] = useState(null) // { url, ts, fromUser, fromName }

  // Estado WS (UX opcional)
  const [wsStatus, setWsStatus] = useState('idle') // idle | connecting | connected | reconnecting | error

  // ========= Helpers UI de tabla =========
  const handleSort = (key) => {
    setSortConfig(prev => {
      if (prev.key === key) {
        return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
      }
      return { key, direction: 'asc' }
    })
  }

//   const processedRows = useMemo(() => {
//     const q = (searchText || '').toLowerCase()
//     const filtered = (allRows || []).filter(row =>
//       (row.name || '').toLowerCase().includes(q) ||
//       (row.lastName || '').toLowerCase().includes(q) ||
//       (row.user || '').toLowerCase().includes(q)
//     )

//     if (!sortConfig.key) return filtered

//     const copy = [...filtered]
//     copy.sort((a, b) => {
//       const A = a[sortConfig.key]
//       const B = b[sortConfig.key]
//       if (typeof A === 'string') {
//         return sortConfig.direction === 'asc'
//           ? (A || '').localeCompare(B || '')
//           : (B || '').localeCompare(A || '')
//       }
//       return sortConfig.direction === 'asc' ? (A - B) : (B - A)
//     })
//     return copy
//   }, [allRows, searchText, sortConfig])

    const processedRows = useMemo(() => {
        const q = (searchText || '').toLowerCase();
        const filtered = (allRows || []).filter(r =>
            (r.name ?? '').toLowerCase().includes(q) ||
            (r.lastName ?? '').toLowerCase().includes(q) ||
            (r.user ?? '').toLowerCase().includes(q)
        );

        if (!sortConfig.key) return filtered;

        const copy = [...filtered];
        copy.sort((a,b) => {
            const A = a[sortConfig.key]; const B = b[sortConfig.key];
            return typeof A === 'string'
            ? (sortConfig.direction === 'asc' ? (A||'').localeCompare(B||'') : (B||'').localeCompare(A||''))
            : (sortConfig.direction === 'asc' ? (A ?? 0) - (B ?? 0) : (B ?? 0) - (A ?? 0));
        });
        return copy;
    }, [allRows, searchText, sortConfig]);

  // ========= Carga inicial =========
  const LoadPage = async () => {
    try {
      const raw = sessionStorage.getItem(process.env.REACT_APP_SESSION)
      const session = raw ? JSON.parse(raw) : null
      //const centerId = session?.user?.centerId || session?.navigation?.centerId || 'C1' // ajusta fuente
      const centerId = session?.navigation?.center?.id // ajusta fuente

      const response = await GetOnlineZtudents(centerId)
      if (response.success) {
        setAllRows(response.data)
      } else {
        console.warn('GetOnlineZtudents error:', response.message)
        setAllRows([])
      }
    } catch (error) {
      await LogErrors('LoadPage - Ztudents', error)
      setAllRows([])
    } finally {
      setIsLoading(false)
    }
  }

  // ========= WS: handler de mensajes =========
  const onWsMessage = (msg) => {
    try {
      switch (msg.type) {
        // Presencia: cuando un ztudiante se conecta
        case 'presence.join': {
          //const z = msg.data // { user, name, surname }
          const z = msg.user // { user, name, surname }
          setAllRows(prev => {
            const exists = prev.some(r => r.user === z.user)
            return exists
              ? prev
              : [{ idZtudiante: z.user, user: z.user, name: z.name, lastName: z.surname }, ...prev]
          })
          break
        }
        // Presencia: cuando un ztudiante se desconecta
        case 'presence.leave': {
            //   //const z = msg.data // { user }
            //   const z = msg.user // { user }
            //   if (!z) break
            //   setAllRows(prev => prev.filter(r => r.user !== z.user))
            //   break

            const userLeft   = (msg.user ?? msg.data?.user ?? '').trim();
            const centerLeft = (msg.centerId ?? msg.data?.centerId ?? '').trim();
            
            if (!userLeft) break;

            // Si manejas multi-centro en la misma vista, filtra por centro:
            const raw = sessionStorage.getItem(process.env.REACT_APP_SESSION);
            const session = raw ? JSON.parse(raw) : {};
            const currentCenter = (session?.user?.centerId ?? session?.navigation?.centerId ?? '').trim();

            // Si llega de otro centro, ignóralo
            if (currentCenter && centerLeft && currentCenter !== centerLeft) break;

            setAllRows(prev => {
                //console.log('[leave] antes:', prev.map(r => r.user));
                //const next = prev.filter(r => (r.user ?? '').trim() !== userLeft);
                const next = prev.filter(r => (r.user ?? '').trim().toLowerCase() !== userLeft.toLowerCase());
                //console.log('[leave] después:', next.map(r => r.user));
                return next;
            });
            break;
        }
        // Snapshot dirigido a ESTE instructor
        case 'snapshot': {
          const { dataUrl, studentUser, studentName, studentSurname, ts } = msg
          setLastSnapshot({
            url: dataUrl,
            ts,
            fromUser: studentUser,
            fromName: `${studentName ?? ''} ${studentSurname ?? ''}`.trim()
          })
          showMessage({ type: MESSAGE_TYPE.INFO, text: `Snapshot recibido de ${studentUser}` })
          break
        }
        // Confirmación opcional del servidor
        case 'request.ack': {
          // { targetUser, capture, ts }
          // Puedes mostrar un toast si quieres
          break
        }
        // Notificación de alumno offline al intentar pedir snapshot
        case 'student.offline': {
          showMessage({ type: MESSAGE_TYPE.WARNING, text: `El Ztudiante ${msg.user.user} está desconectado.` })
          break
        }
        default:
          // Mensajes que no necesitamos manejar aquí
          break
      }
    } catch (err) {
      console.error('[WS] onMessage error:', err)
    }
  }

  // ========= Bootstrap: valida sesión, carga lista, conecta WS =========
  useEffect(() => {
    async function bootstrap() {
      const tmpSession = await ValidateSession()
      if (!tmpSession?.success) {
        navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
        return
      }
      if (tmpSession.data.user.userStatus !== 2) {
        navigate('/confirm')
        return
      }

      await LoadPage()

      // Datos para identificación del instructor en WS
      const raw = sessionStorage.getItem(process.env.REACT_APP_SESSION)
      const session = raw ? JSON.parse(raw) : {}
      //const centerId = session?.user?.centerId || tmpSession.data?.user?.centerId || 'C1'
      const centerId = session?.navigation?.center?.id || tmpSession.data?.navigation?.center?.id
      //const user = session?.user?.user || tmpSession.data?.user?.user || 'inst1'
      const user = session?.navigation?.username || tmpSession.data?.navigation?.username
      const name = session?.user?.name || tmpSession.data?.user?.name || ''
      const surname = session?.user?.lastName || tmpSession.data?.user?.lastName || ''

      WsMonitor.setMessageHandler(onWsMessage)
      WsMonitor.connectInstructor({
        urlWss: WSS_URL,
        centerId,
        user,
        name,
        surname,
        onStatusChange: setWsStatus,
        onToast: (t) => console.log('[WS]', t)
      })

      // (Opcional) auto-refresh lista cada 15s para robustez
      // const t = setInterval(LoadPage, 15000)
      // return () => clearInterval(t)
    }

    bootstrap()

    return () => {
      WsMonitor.setMessageHandler(null)
      WsMonitor.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ========= Confirm Modal: “Ver ahora” =========
  const ShowConfirmModal = async (actionType, ztudent) => {
    try {
      if (actionType === ACTIONS.VIEWNOW && ztudent) {
        setActionTypeOfModal(actionType)
        setZtudentConfirmDetails(ztudent)
        setShowConfirmationModal(true)
      } else {
        setActionTypeOfModal(null)
        setZtudentConfirmDetails(null)
        setShowConfirmationModal(false)
      }
    } catch (error) {
      await LogErrors('ShowConfirmModal - Ztudents', error)
    }
  }

  // Enviar solicitud al WS
  const RequestSnapshot = async () => {
    try {
      if (!ztudentConfirmDetails) return { success: false, message: 'Sin Ztudiante' }
      if (!WsMonitor.isReady()) {
        showMessage({ type: MESSAGE_TYPE.WARNING, text: 'Conectando… intenta de nuevo en un momento.' })
        return { success: false, message: 'WS no listo' }
      }

      const ok = WsMonitor.send({
        type: 'request-snapshot',
        targetUser: ztudentConfirmDetails.user,
        capture: 'viewport' // 'fullpage' → pantalla completa del ztudiante, 'viewport' | 'element'
      })

      if (ok) {
        showMessage({ type: MESSAGE_TYPE.INFO, text: `Solicitud enviada a ${ztudentConfirmDetails.user}` })
        return { success: true }
      } else {
        showMessage({ type: MESSAGE_TYPE.ERROR, text: 'No fue posible enviar la solicitud.' })
        return { success: false, message: 'send() falló' }
      }
    } catch (err) {
      await LogErrors('RequestSnapshot - Ztudents', err)
      return { success: false, message: err.message }
    }
  }


  //useTawkChat(true) // Activamos el chat en esta página


  // ==========================
  // Render
  // ==========================
  return (
    isLoading ? (
      <Loading />
    ) : (
      <InstructorBase urlToGo={'/dashboard'} page={WEBPAGES.INSTRUCTOR.ZTUDENTVIEW} role={ROLES.INSTRUCTOR}>
        <section className='container Instructor__Ztudents'>
          <p className='Instructor__Title Instructor__Title--Center'>Mis Ztudiantes</p>
          <p className='Instructor__Text--Center' style={{ opacity: 0.7, marginTop: -8 }}>
            Estado WS: {wsStatus}
          </p>

          {/* Buscador */}
          <Search onChange={(v) => setSearchText(v)} extraClassName={'Instructor__SpaceUp'} />

          {/* Tabla única */}
          <div className='container Instructor__SpaceUp'>
            {processedRows.length === 0 ? (
              <p className='Instructor__Text--Center Instructor__SpaceUp'>
                {allRows.length === 0
                  ? 'Actualmente no hay Ztudiantes conectados a tu centro.'
                  : 'No hay coincidencias con tu búsqueda.'}
              </p>
            ) : (
              <section className='Tables__Container Tables--Shadow Tables--Background'>
                <table className='Tables__Table Instructor__Ztudents__Visible__ContainerTable__Table'>
                  <thead>
                    <tr className='Tables__Table__Row--Header'>
                      <td
                        className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn'
                        onClick={() => handleSort('name')}
                      >
                        Nombre(s) {sortConfig.key === 'name' && <span>{sortConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}
                      </td>
                      <td
                        className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn'
                        onClick={() => handleSort('lastName')}
                      >
                        Apellido(s) {sortConfig.key === 'lastName' && <span>{sortConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}
                      </td>
                      <td
                        className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__TextColumn'
                        onClick={() => handleSort('user')}
                      >
                        Usuario {sortConfig.key === 'user' && <span>{sortConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>}
                      </td>
                      <td className='Tables__Table__Row__Cell Tables__Table__Header Tables__Table__ActionButtonsColumn'></td>
                    </tr>
                  </thead>
                  <tbody>
                    {/*processedRows.map((row, idx) => (*/}
                    {processedRows.map((row) => row && row.user && (
                      <tr key={row.user} className='Tables__Table__Row'>
                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn'>{row.name}</td>
                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn'>{row.lastName}</td>
                        <td className='Tables__Table__Row__Cell Tables__Table__TextColumn'>{row.user}</td>
                        <td className='Tables__Table__Row__Cell Tables__Table__ActionButtonsColumn'>
                          <button
                            className='Btn__Ztudia--PrimaryOutline'
                            onClick={() => ShowConfirmModal(ACTIONS.VIEWNOW, row)}
                          >
                            Ver ahora
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section>
            )}
          </div>

          {/* Visor de snapshot (debajo de la tabla) */}
          {lastSnapshot && (
            <div className='Instructor__SpaceUp' style={{ maxWidth: 980, margin: '24px auto' }}>
              <div style={{ display: 'flex', gap: 12, alignItems: 'baseline' }}>
                <strong>Último snapshot</strong>
                <small>
                  ({new Date(lastSnapshot.ts).toLocaleTimeString()} — de {lastSnapshot.fromUser}{lastSnapshot.fromName ? ` / ${lastSnapshot.fromName}` : ''})
                </small>
              </div>
              <img
                alt='snapshot'
                src={lastSnapshot.url}
                style={{ marginTop: 8, width: '100%', borderRadius: 12, border: '1px solid #ddd' }}
              />
            </div>
          )}

          {/* Modal de confirmación */}
          {showConfirmationModal && actionTypeOfModal === ACTIONS.VIEWNOW && ztudentConfirmDetails && (
            <Confirm
              message={`¿Solicitar snapshot ahora a ${ztudentConfirmDetails?.name} ${ztudentConfirmDetails?.lastName} (${ztudentConfirmDetails?.user})?`}
              textYesButton={'Sí, ver ahora'}
              textNoButton={'No'}
              setShowModal={setShowConfirmationModal}
              setConfirmData={setZtudentConfirmDetails}
              actionToYesButton={async () => {
                const resp = await RequestSnapshot()
                // Devolver resp permite que el modal decida si se cierra o muestra error
                return resp
              }}
            />
          )}
        </section>
      </InstructorBase>
    )
  )
}

export { ZtudentView };